module.exports = __webpack_public_path__ + "static/elder_brain-ed856925a37664447f851cfdbb0d59d0.png";